
import { render } from '@testing-library/react';
import React, { useState, useEffect } from 'react';

const UploadImg = () => {
    const [seeImg, setSeeImg] = useState(null);

    const saveFile = async (e) => {
        setSeeImg(e.target.files[0])
        console.log(seeImg, e.target.files[0], 'llego')

        // if (seeImg != null) {
        const image = document.getElementById("image-selected");
        // console.log(e.target.files[0], image)
        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (e) => {
            e.preventDefault();
            image.setAttribute('src', e.target.result)
            // }
        }
    }


    return (
        <div>
            <input type="file" onChange={saveFile} accept="image/x-png,image/gif,image/jpeg" />

            {/* {
                seeImg != null ? (<img src="" alt="" id="image-selected" height="150px" width="150px" />) : (<></>)
            } */}
            <img src="" alt="" id="image-selected" height="150px" width="150px" />


        </div>
    )

}

export default UploadImg